import React from 'react'
import { observer } from 'mobx-react-lite'
import { useSidebarCollapse } from '../../../contexts/SidebarCollapseContext'
import ClientsList from './ClientsList'
import FoldersList from './FoldersList'
import ClientCampaignsPage from './ClientCampaignsPage'
import ClientCampaignsList from './ClientCampaignsList'
import { useParams } from 'react-router-dom'
import RecentlyOpenedCampaignsList from './RecentlyOpenedCampaignsList'

export default observer(function CampaignsIndex() {
  const { client_id, folder_id } = useParams()
  const { isCollapsed } = useSidebarCollapse()
  const isClientPage = client_id && !folder_id

  if (isClientPage) {
    return <ClientCampaignsPage />
  }

  return (
    <div className={`fixed pt-72 ${isCollapsed ? 'pl-32' : 'pl-56'} w-full h-full bg-rb-grey dark:bg-rb-dark-mode-background -z-10 overflow-y-auto transition-all duration-300`}>
      {!folder_id && <RecentlyOpenedCampaignsList />}
      {
        !client_id && !folder_id && (
          <>
            <ClientsList />
            <FoldersList />
          </>
        )
      }
      { folder_id && <ClientCampaignsList /> }
    </div>
  )
})
